/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Primary_Group_LabelInputs */



/**
* | output |
* | --- |
* | "Primary Event Group" |
*
* @param {Metadata_Merge_Primary_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_primary_group_label = /** @type {((inputs?: Metadata_Merge_Primary_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Primary_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe d'événements principaux")
	if (locale === "de") return /** @type {LocalizedString} */ ("Primäre Veranstaltungsgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo principale dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Основная группа событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de eventos primarios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("主要事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("主要イベントグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्राथमिक कार्यक्रम समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Eventos Primários")
	return /** @type {LocalizedString} */ ("Primary Event Group")
});